import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail/conference-icon.svg';
const ConferenceSvg = () => React.createElement(IconSvg, null);
export default ConferenceSvg;
